<template>
  <ds-search-select
    v-model="employee"
    required
    compare-value-by="id"
    :selected-option="employeeSelected"
    :on-query="onQuery"
    :on-query-success="onQuerySuccess"
    :on-fetch="onFetch"
    :on-fetch-success="onFetchSuccess"
    :custom-validations="customValidations"
    @input="onEmployeeChange">
    <ds-option
      v-for="employeeOption in employees"
      :key="employeeOption.id"
      :value="employeeOption">
      {{ employeeOption.name }}
    </ds-option>
  </ds-search-select>
</template>

<script>
import { searchForWorkers, getWorkerParsed } from 'accountant/worker/src/modules/workers/workersService';

export default {
  name: 'EmployeeSearchSelect',
  props: {
    index: {
      type: Number,
      required: true,
    },
    competence: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    allocations: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      employeeSelected: null,
      employees: [],
      employee: this.value,
    };
  },
  computed: {
    customValidations() {
      const { allocations, index } = this;
      return [{
        message: 'Este funcionário já foi selecionado anteriormente',
        valid({ id }) {
          return allocations
            .filter((_, indexList) => index !== indexList)
            .every(({ employee }) => id !== employee?.id);
        },
      }];
    },
  },
  methods: {
    async onFetch(employee) {
      return !employee.id
        ? Promise.resolve(null)
        : getWorkerParsed(employee.id);
    },
    onFetchSuccess(employee) {
      if (!employee) return;
      this.employeeSelected = {
        value: employee,
        label: employee.name,
      };
    },
    onEmployeeChange(inputData) {
      const employee = {
        id: inputData.id,
        name: inputData.name,
      };
      this.$emit('input', employee);
    },
    onQuery(term) {
      return searchForWorkers(term || '');
    },
    onQuerySuccess(response) {
      this.employees = response;
    },
  },
};
</script>
